import { Koi } from '@ksyos/koi';
import type { ProcessActivityAsset } from './processActivityAsset';
import type { ISchemaContainer } from './schemaContainer';
import { DiaryTypes } from '../enums/diaryTypes';
import { getProcessActivityAssetsSchema } from './processActivityAsset';

export interface IDiaryValidated {
    assets: ProcessActivityAsset[];
    diaryType: DiaryTypes;
}

export interface IDiaryData {
    assets: ProcessActivityAsset[];
    diaryType?: DiaryTypes | 'uploadDiaryLater';
}

export const diary = Koi.object({
    assets: Koi.when('diaryType', {
        is: DiaryTypes.paperUpload,
        otherwise: getProcessActivityAssetsSchema(),
        then: getProcessActivityAssetsSchema({ max: 25, min: 1 }),
    }),
    diaryType: Koi.koi().enum(DiaryTypes),
});

export const diarySchema: ISchemaContainer<IDiaryValidated> = {
    schema: diary.options({ convert: false, presence: 'required', stripUnknown: true }),
};
